"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuctionList = void 0;
const vue_1 = require("vue");
const complex_data_1 = require("complex-data");
const plugin_1 = require("@/plugin");
const ListView_1 = __importDefault(require("@/components/data/ListView"));
const litigation_1 = __importDefault(require("@/pages/index/api/litigation"));
const dictionary_1 = require("@/config/dictionary");
const litigation_2 = require("@/pages/index/select/litigation");
const config_1 = require("@/config/dictionary/config");
const complex_plugin_1 = require("complex-plugin");
class AuctionList extends complex_data_1.ComplexList {
    buildItem(postData) {
        return new Promise((resolve, reject) => {
            postData.litigationRecordId = this.$getExtra('litigationRecordId');
            litigation_1.default.litigationAuctionBuild.require(postData).then(() => {
                this.$reloadData({
                    force: true
                }).finally(() => {
                    resolve({ status: 'success' });
                });
            }).catch(err => {
                // eslint-disable-next-line no-console
                console.error(err);
                reject(err);
            });
        });
    }
    changeItem(postData, originData) {
        return new Promise((resolve, reject) => {
            postData.id = originData.id;
            litigation_1.default.litigationAuctionChange.require(postData).then(() => {
                this.$reloadData({
                    force: true
                }).finally(() => {
                    resolve({ status: 'success' });
                });
            }).catch(err => {
                // eslint-disable-next-line no-console
                console.error(err);
                reject(err);
            });
        });
    }
}
exports.AuctionList = AuctionList;
exports.default = (0, vue_1.defineComponent)({
    name: 'AuctionList',
    components: {
        ListView: ListView_1.default
    },
    props: {
        id: {
            type: String,
            required: true
        },
        unOperate: {
            type: Boolean,
            required: false
        }
    },
    data() {
        return {
            mainData: new AuctionList({
                name: '评估拍卖',
                prop: 'auctionList',
                module: {
                    dictionary: {
                        layout: {
                            default: {
                                grid: 12,
                                label: 8,
                                content: 16
                            }
                        },
                        option: {},
                        propData: {
                            id: 'id'
                        },
                        list: [
                            {
                                prop: 'id',
                                name: 'ID',
                                originProp: 'id',
                                originFrom: 'list',
                                mod: {}
                            },
                            {
                                prop: 'litigationRecordId',
                                name: '法诉ID',
                                originProp: 'litigationRecordId',
                                originFrom: 'list',
                                mod: {}
                            },
                            (0, dictionary_1.buildDictionaryBySelect)(litigation_2.auctionStatus, {
                                prop: 'auctionType',
                                name: '法拍类型',
                                originProp: 'auctionType',
                                // edit(value: any) {
                                //   return value
                                // },
                                // post(value: any) {
                                //   return value
                                // },
                                mod: {
                                    list: {},
                                    edit: {
                                        required: true,
                                        disabled: true
                                    },
                                    build: {
                                        $target: 'edit'
                                    },
                                    change: {
                                        $target: 'edit'
                                    }
                                }
                            }),
                            {
                                prop: 'evaluationAmount',
                                name: '评估金额',
                                originProp: 'evaluationAmount',
                                originFrom: 'list',
                                mod: {
                                    list: {},
                                    edit: {
                                        type: 'inputNumber',
                                        option: {
                                            min: 0,
                                            precision: 2
                                        },
                                        required: true
                                    },
                                    build: {
                                        $target: 'edit'
                                    },
                                    change: {
                                        $target: 'edit'
                                    }
                                }
                            },
                            {
                                prop: 'startingPrice',
                                name: '起拍价',
                                originProp: 'startingPrice',
                                originFrom: 'list',
                                mod: {
                                    list: {},
                                    edit: {
                                        type: 'inputNumber',
                                        option: {
                                            min: 0,
                                            precision: 2
                                        },
                                        required: false
                                    },
                                    build: {
                                        $target: 'edit'
                                    },
                                    change: {
                                        $target: 'edit'
                                    }
                                }
                            },
                            {
                                prop: 'transactionPrice',
                                name: '成交价',
                                originProp: 'transactionPrice',
                                originFrom: 'list',
                                mod: {
                                    list: {},
                                    edit: {
                                        type: 'inputNumber',
                                        option: {
                                            min: 0,
                                            precision: 2
                                        },
                                        required: false
                                    },
                                    build: {
                                        $target: 'edit'
                                    },
                                    change: {
                                        $target: 'edit'
                                    }
                                }
                            },
                            {
                                prop: 'remark',
                                name: '备注',
                                originProp: 'remark',
                                originFrom: 'list',
                                mod: {
                                    list: {
                                        width: config_1.listWidth.getWidth(10)
                                    },
                                    edit: {
                                        type: 'textArea',
                                        required: false
                                    },
                                    build: {
                                        $target: 'edit'
                                    },
                                    change: {
                                        $target: 'edit'
                                    }
                                }
                            },
                            {
                                prop: 'createdBy',
                                name: '无',
                                originProp: 'createdBy',
                                originFrom: 'list',
                                mod: {}
                            },
                            {
                                prop: 'createdTime',
                                name: '无',
                                originProp: 'createdTime',
                                originFrom: 'list',
                                mod: {}
                            },
                            {
                                prop: 'updatedBy',
                                name: '无',
                                originProp: 'updatedBy',
                                originFrom: 'list',
                                mod: {}
                            },
                            {
                                prop: 'updatedName',
                                name: '更新人',
                                originProp: 'updatedName',
                                originFrom: 'list',
                                mod: {
                                    list: {
                                        width: config_1.listWidth.personnelName
                                    }
                                }
                            },
                            {
                                prop: 'updatedTime',
                                name: '更新时间',
                                originProp: 'updatedTime',
                                originFrom: 'list',
                                mod: {
                                    list: {
                                        width: config_1.listWidth.time
                                    }
                                }
                            },
                            {
                                prop: 'menu',
                                name: '操作',
                                originProp: 'menu',
                                originFrom: 'local',
                                mod: {
                                    list: {
                                        width: config_1.listWidth.getWidth(2)
                                    }
                                }
                            },
                        ]
                    }
                },
                $getData() {
                    return new Promise((resolve, reject) => {
                        litigation_1.default.litigationAuctionList.require({
                            litigationRecordId: this.$getExtra('litigationRecordId')
                        }).then(res => {
                            this.$formatList(res.data.data, res.data.totalCount);
                            resolve({ status: 'success' });
                        }).catch(err => {
                            // eslint-disable-next-line no-console
                            console.error(err);
                            reject(err);
                        });
                    });
                }
            }),
            next: null
        };
    },
    computed: {
        width() {
            return this.getWidth();
        },
        operate() {
            return this.mainData.$getStatus('operate') === 'ing';
        },
        listOption() {
            return {
                table: {
                    optionProps: {
                        bordered: true,
                        scroll: {
                            x: this.getWidth()
                        }
                    }
                },
                search: false,
                menu: {
                    list: [
                        {
                            prop: 'change',
                            name: '编辑',
                            hidden: () => {
                                return this.unOperate;
                            }
                        }
                    ]
                },
                info: {
                    modal: {
                        optionProps: {
                            width: 960
                        }
                    }
                },
                edit: {
                    modal: {
                        optionProps: {
                            width: 960
                        }
                    }
                }
            };
        }
    },
    watch: {
        id: {
            immediate: true,
            handler(val) {
                if (val) {
                    this.mainData.$setExtra('litigationRecordId', this.id);
                    this.loadData();
                }
            }
        }
    },
    beforeUnmount() {
        this.mainData.$reset();
    },
    methods: {
        getWidth() {
            return plugin_1.reactiveLayout.data.main.width - 16 * 2;
        },
        loadData() {
            this.mainData.$reloadData(true);
            this.loadNext();
        },
        loadNext() {
            return new Promise((resolve, reject) => {
                litigation_1.default.litigationAuctionNext.require({
                    litigationRecordId: this.id
                }).then(res => {
                    this.next = res.data.data;
                    resolve(res);
                }).catch(err => {
                    this.next = null;
                    // eslint-disable-next-line no-console
                    console.error(err);
                    reject(err);
                });
            });
        },
        onBuild() {
            this.loadNext().then(() => {
                if (this.next) {
                    this.$refs['list-view'].openEdit('build', '新增', {
                        auctionType: litigation_2.auctionStatus.getItem(this.next)
                    });
                }
                else {
                    complex_plugin_1.notice.showMsg('当前法诉不存在下一步评估拍卖！', 'warn');
                }
            });
        }
    }
});
